// extracted by mini-css-extract-plugin
module.exports = {"devicesD":"D_devicesD__CEmZ0"};